var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUndoDeletingofannotation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Undo",
    "data-name": "Icon / Undo",
    opacity: 0.995
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15230",
    "data-name": "Path 15230",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11 1 C 5.485979080200195 1 1 5.485979080200195 1 11 C 1 16.51401901245117 5.485979080200195 21 11 21 C 16.51401901245117 21 21 16.51401901245117 21 11 C 21 5.485979080200195 16.51401901245117 1 11 1 M 11 0 C 17.07513046264648 0 22 4.924869537353516 22 11 C 22 17.07513046264648 17.07513046264648 22 11 22 C 4.924869537353516 22 0 17.07513046264648 0 11 C 0 4.924869537353516 4.924869537353516 0 11 0 Z",
    stroke: "none",
    fill: "#ff9131"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-undo-alt",
    "data-name": "Icon awesome-undo-alt",
    d: "M6.139.562A5.568,5.568,0,0,0,2.29,2.11l-.8-.8a.541.541,0,0,0-.923.382v3.02a.541.541,0,0,0,.541.541h3.02a.541.541,0,0,0,.382-.923l-.941-.941A3.784,3.784,0,1,1,3.657,9a.27.27,0,0,0-.369.012L2.395,9.9a.271.271,0,0,0,.011.393A5.587,5.587,0,1,0,6.139.562Z",
    transform: "translate(4.851 4.851)",
    fill: "#ff9131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndoDeletingofannotation);
export default __webpack_public_path__ + "static/media/Icon - Undo Deleting of annotation.f22ac073b75db38125bcd002efdfe283.svg";
export { ForwardRef as ReactComponent };